import { render, staticRenderFns } from "./LookArticulo.vue?vue&type=template&id=1dad5248"
import script from "./LookArticulo.vue?vue&type=script&lang=js"
export * from "./LookArticulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports